/* tslint:disable */

/**
 */
export class SubscriptionType {
    id?: number;
    comany_id?: number;
    name?: string;
    display_name?: string;
    duration?: number;
    price?: number;
    created_at?: string;
    updated_at?: string;
}
